import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityDepartamentosState,
  entityDepartamentosAdapter
} from './entity-departamentos.state';
import {
  entityDepartamentosLoadFailure,
  entityDepartamentosLoadRequest,
  entityDepartamentosLoadSuccess
} from './entity-departamentos.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityDepartamentosLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityDepartamentosLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityDepartamentosLoadSuccess, (state, { items }) =>
    entityDepartamentosAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function departamentosReducer(
  state: EntityDepartamentosState | undefined,
  action: Action
) {
  return reducer(state, action);
}
